module.exports = __webpack_public_path__ + "img/footer-background-2.7203d54a.png";